import { GraphQL } from "@rpi/openapi-api";
import React from "react";

export const PAYMENT_STATUS_NAMES: Record<GraphQL.PaymentStatus, string> = {
  [GraphQL.PaymentStatus.ExternallyPaid]: "Externally Paid",
  [GraphQL.PaymentStatus.Paid]: "Paid",
  [GraphQL.PaymentStatus.Unpaid]: "Unpaid",
  [GraphQL.PaymentStatus.NoPaymentStaffOrder]: "No Payment - Staff Order",
  [GraphQL.PaymentStatus.PaymentPending]: "No Payment - Payment Pending",
};

interface OrderPaymentStatusCellProps {
  status?: GraphQL.PaymentStatus | null;
}

export const OrderPaymentStatusCell: React.FC<OrderPaymentStatusCellProps> = ({ status }) => {
  if (!status) return <></>;
  return <>{PAYMENT_STATUS_NAMES[status]}</>;
};
